/**
 * Transparent Sticky Header Script
 *
 * This script extends Dawn's native sticky header behavior to:
 * 1. Track when header is revealed after scrolling
 * 2. Add a persistent class that keeps the header styled blue
 * 3. Reset to transparent when scrolling back to the top
 */

(function () {
  "use strict";

  function initTransparentHeader() {
    const sectionHeader = document.querySelector(".section-header");

    if (!sectionHeader) return;

    // Only run transparent header logic on homepage
    // On interior pages, CSS handles the always-blue styling
    const isHomepage = document.body.classList.contains("page-type-homepage");
    if (!isHomepage) return;

    let hasScrolledPast = false;
    let lastScrollY = window.scrollY;
    const headerHeight = sectionHeader.offsetHeight || 100;

    window.addEventListener(
      "scroll",
      function () {
        const currentScrollY = window.scrollY;

        // Detect when user has scrolled past the header
        if (currentScrollY > headerHeight) {
          hasScrolledPast = true;
        }

        // Scrolling UP after having scrolled past header (but not at top)
        if (hasScrolledPast && currentScrollY < lastScrollY && currentScrollY > headerHeight) {
          sectionHeader.classList.add("header--scrolled-revealed");
        }

        // At the very top of the page - reset to transparent
        if (currentScrollY <= 10) {
          hasScrolledPast = false;
          sectionHeader.classList.remove("header--scrolled-revealed");
        }

        lastScrollY = currentScrollY;
      },
      { passive: true }
    );
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTransparentHeader);
  } else {
    initTransparentHeader();
  }
})();
